import SalaryTable from './SalaryTable';

export default SalaryTable;
